document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('[data-carousel]');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('img'));
    if (slides.length <= 1) return;

    const prevBtn = carousel.querySelector('.spa-carousel-btn.prev');
    const nextBtn = carousel.querySelector('.spa-carousel-btn.next');
    const dotsWrap = carousel.querySelector('[data-dots]');
    const countEl = carousel.querySelector('[data-count]');

    let index = 0;

    /* Crear dots */
    let dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'spa-carousel-dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;

      if (countEl) {
        countEl.textContent = `${index + 1}/${slides.length}`;
      }

      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    function next() {
      if (index < slides.length - 1) {
        index++;
        update();
      }
    }

    function prev() {
      if (index > 0) {
        index--;
        update();
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    /* Swipe táctil */
    let startX = 0;
    let isDragging = false;

    track.addEventListener('pointerdown', (e) => {
      isDragging = true;
      startX = e.clientX;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointerup', (e) => {
      if (!isDragging) return;
      const diff = e.clientX - startX;

      if (diff < -50) next();
      if (diff > 50) prev();

      isDragging = false;
    });

    update();
  });
});
